import axios from 'axios';
import { variables } from "../Variables";

// get client setting from local db
export const getClientSettingsFromLocalDB = async (clientToken, officeId) => {
    try {
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            }
        };

        const url = variables.API_URL + `Settings/GetSetting?officeId=` + officeId;

        const response = await axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
        return response.data;
    } catch (error) {
        console.log(error)
    }
}